// Module
var code = "<div class=\"abx-y-axis-label__container\"> <span ng-bind=\"vm.text\"></span> </div> ";
// Exports
module.exports = code;